<div class="header-padding">
<div class="header-container">
    <div class="report-info">
        <h2 class="report-title">Database</h2>
        <p class="report-subtitle">
            <span class="subtitle-span">Drill Shift Details</span> - visualizes
        </p>
    </div>
    <div class="export-btn">
		<button mat-button class="export-pdf-btn primary cta" (click)="initiateDrillShiftDetails()">
			<mat-icon svgIcon="addIcon" class="svg-icon"></mat-icon>
			Drill Shift Details
		</button>
		<button *ngIf="currentDrillShiftDetail && !currentDrillShiftDetail.id" mat-button class="export-pdf-btn primary cta" (click)="submitDrillShiftDetails()">Submit</button>
		<button mat-button class="export-pdf-btn primary cta" (click)="exportToCSV()">
			<mat-icon class="svg-icon" svgIcon="pdfIcon"></mat-icon>
			Export to CSV
		</button>
    </div>
</div>
</div>
<div class="content-container">
    <div class="excel-style-container">
        <div class="table-container">
			<table class="data  mat-elevation-z1 excel-table" mat-table [dataSource]="dataSource">
				<ng-container matColumnDef="projectName" sticky>
					<th mat-header-cell *matHeaderCellDef>Project</th>
					<td [ngClass]="{'border-bottom-none' : element.isFirstRow || element.isMiddleRow, 'border-top-none': element.isLastRow || element.isMiddleRow, 'total-row': element.isTotalRow}" mat-cell *matCellDef="let element">
						<ng-container *ngIf="!element.id; else displayColumn">
							<mat-select (selectionChange)="onDatasetSelect($event)" class="select-project">
								<mat-option *ngFor="let dataset of siteDatasetLists" [value]="dataset">{{dataset.name}}</mat-option>
							</mat-select>
						</ng-container>
						<ng-template #displayColumn>
							<ng-container *ngIf="element.isTotalRow">
								<span><strong>Total</strong></span>
							</ng-container>
							<ng-container *ngIf="!element.isTotalRow && element.showProjectName">
								<span>{{ element.projectName }}</span>
							</ng-container>
						</ng-template>
					</td>
				</ng-container>

				<ng-container [matColumnDef]="col.key" *ngFor="let col of dataSourceSchema">
					<th mat-header-cell *matHeaderCellDef sticky>{{ col.label }}</th>
					<td mat-cell *matCellDef="let element" [ngClass]="{ 'total-row': element.isTotalRow }">
						<ng-container *ngIf="element.isTotalRow; else editableInput">
							<span>{{ element[col.key] }}</span>
						</ng-container>
						<ng-template #editableInput>
							<input
							[type]="col.type"
							matInput
							[(ngModel)]="element[col.key]"
							[readonly]="col.readonly"
							(click)="onFieldInputClick?.(col.key)"
							(ngModelChange)="onFieldInputChange?.(element, col.key, $event)" />
						</ng-template>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
			</table>
		</div>
    </div>

    <mat-paginator
        pageSize="30"
        [pageSizeOptions]="[30, 40]"
        hidePageSize="true"
    >
    </mat-paginator>
</div>

<div class="loading-container" *ngIf="loadingDrillShiftDetails">
    <mat-spinner matTooltip="Loading Drill Shift Details"></mat-spinner>
</div>
